// extracted by mini-css-extract-plugin
export default {"navigation":"previousBillsDialog_navigation__BdT18"};